import Swiper from "swiper";
import { Navigation } from "swiper/modules";

import "swiper/css";
import "swiper/css/navigation";

export default function swiperPropertyAreas() {
    const swiper = new Swiper(".swiper-area-guides", {
        modules: [Navigation],

        // Params
        loop: false,
        grabCursor: true,
        speed: 800,
        slidesPerView: 2,
        slidesPerGroup: 1,
        spaceBetween: 8,

        // Navigation
        navigation: {
            prevEl: ".swiper-area-guides > .swiper-button-prev",
            nextEl: ".swiper-area-guides > .swiper-button-next",
        },

        breakpoints: {
            768: {
                slidesPerView: 3,
            },
        },
    });
}
